<template>
  <div class="modal-wrap">
    <el-dialog title="自定义制作人员分组" lock-scroll :visible.sync="dialogVisible" width="596px" :close-on-click-modal="false">
      <div class="form-wrap">
        <el-table
          :data="list"
          style="flex: 1"
          v-loading="loading"
          element-loading-text="拼命加载中"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.1)"
          ref="table"
          :max-height="600"
        >
          <el-table-column label="制作小组" prop="productGroup" width="150">
            <template slot-scope="scope">
              <el-input
                v-if="editDataSet[scope.row.id]"
                v-model="editDataSet[scope.row.id].productGroup"
                class="input-area"
                placeholder="请输入"
                resize="none"
              >
              </el-input>
              <div v-else class="show-text">
                <span>{{ scope.row.productGroup }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="素材制作人员" prop="productor" width="250">
            <template slot-scope="scope">
              <el-select
                v-if="editDataSet[scope.row.id]"
                v-model="editDataSet[scope.row.id].productor"
                class="input-area"
                multiple
                filterable
                allow-create
                placeholder="请选择"
                resize="none"
              >
                <el-option v-for="item in editDataSet[scope.row.id].options" :key="item" :label="item" :value="item"> </el-option>
              </el-select>
              <div v-else class="show-text">
                <span>{{ scope.row.productor }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <div v-if="editDataSet[scope.row.id]">
                <i class="el-icon-close" @click="cancelEdit(scope.row)"></i>
                <i class="el-icon-check" @click="saveEdit(scope.row)"></i>
              </div>
              <div v-else>
                <el-button class="delete-btn" type="text" @click="handleEdit(scope.row)">编辑</el-button>
                <el-button class="delete-btn" type="text" @click="handleDelete(scope.row)">删除</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer" @click="addproductGroup"><i class="el-icon-plus"></i> 新增小组</div>
    </el-dialog>
  </div>
</template>

<script>
import { getProductorList, addProductor, delProductor } from "@/api/materialManage.js";
export default {
  name: "TimeModal",
  data() {
    return {
      dialogVisible: false,
      loading: false,
      list: [],
      editDataSet: {},
      mode: "",
    };
  },
  methods: {
    getList() {
      this.editDataSet = {};
      getProductorList().then((res) => {
        this.list = res.data;
      });
    },
    showModal() {
      this.getList();
      this.dialogVisible = true;
    },
    addproductGroup() {
      this.mode = "add";
      const newData = { id: Math.random(), productGroup: "", productor: [] };
      this.$set(this.editDataSet, newData.id, newData);
      this.list.push(newData);
    },
    handleEdit(row) {
      this.mode = "edit";
      const data = JSON.parse(JSON.stringify(row));
      data.productor = data.productor.split("、");
      data.options = data.productor;
      this.$set(this.editDataSet, row.id, data);
    },
    cancelEdit(row) {
      if (row.id < 1) {
        const index = this.list.findIndex((item) => item.id === row.id);
        this.list.splice(index, 1);
      } else {
        this.$delete(this.editDataSet, row.id);
      }
    },
    saveEdit(row) {
      let curRow = this.list.find((item) => item.id === row.id);
      let reqData = Object.assign(JSON.parse(JSON.stringify(curRow)), this.editDataSet[row.id]);
      delete reqData.options;
      let flag = true;
      reqData.productor.forEach((item) => {
        if (!item.trim()) {
          flag = false;
        }
      });
      if (!flag) {
        this.$message({ message: "素材制作人员不能存在空字符", type: "warning" });
        return;
      }
      reqData.productor = reqData.productor.join("、");
      if (reqData.id < 1) {
        delete reqData.id;
      }
      if (!reqData.productor.trim()) {
        this.$message({ message: "素材制作人员不能为空", type: "warning" });
        return;
      }
      if (!reqData.productGroup.trim()) {
        this.$message({ message: "制作小组不能为空", type: "warning" });
        return;
      }
      addProductor(reqData).then((res) => {
        if (res.code === "0000") {
          this.$message({
            message: "修改成功",
            type: "success",
          });
          Object.assign(curRow, this.editDataSet[row.id]);
          this.$delete(this.editDataSet, row.id);
          this.getList();
        }
      });
    },
    handleDelete(row) {
      this.$confirm("确定删除制作小组“" + row.productGroup + "”?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          delProductor({ id: row.id }).then((res) => {
            if (res.code === "0000") {
              this.$message({
                message: "删除成功",
                type: "success",
              });
              this.getList();
            }
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="less" scoped>
.modal-wrap {
  /deep/ .el-dialog__title {
    font-weight: 500;
  }
  /deep/ .el-table {
    border-bottom: none;
  }
  .dialog-footer {
    width: 530px;
    height: 47px;
    border-radius: 0 0 4px 4px;
    background: rgba(251, 251, 251, 1);
    text-align: center;
    line-height: 47px;
    color: rgba(24, 144, 255, 1);
    margin-top: -24px;
    margin-left: -2px;
    border: 1px solid rgba(240, 240, 240, 1);
    border-top: none;
  }
  .el-icon-close {
    font-size: 18px;
    cursor: pointer;
  }
  .el-icon-check {
    margin-left: 12px;
    color: rgb(24, 144, 255);
    font-size: 18px;
    cursor: pointer;
  }
}
</style>
